

// send email at popup window login/register form
function sendEmail() {
    customer_email = $($('#getCodeFrom input[name="contact[email]"]')).val();
    console.log('eeeeeeeeee', customer_email)

    person = {
        "email": customer_email,
        "status": "subscribed",
        "fields": {
            "email": customer_email,
            "status": "subscribed",
        }
    };

    last_data = JSON.stringify(person)

    sendHTTPRequest(last_data)


}




// send email at account page login/register form
// $(".sendAccountEmail").click(function () {
//     customer_email = $($('#customer_login input[name="customer[email]"]')[2]).val() == '' ? $($('#create_customer input[name="customer[email]"]')[2]).val() : $($('#customer_login input[name="customer[email]"]')[2]).val();
//     console.log('eeeeeeeeee', customer_email)

//     person = {
//         "email": customer_email,
//         "status": "subscribed",
//         "fields": {
//             "email": customer_email,
//             "status": "subscribed",
//         }
//     };

//     last_data = JSON.stringify(person)

//     sendHTTPRequest(last_data)

// });


// making http requiest to omniosend email automization
function sendHTTPRequest(form_data) {

    $.ajax({
        url: 'https://api.omnisend.com/v3/events/61b6eeff84a0a70020ffbf01',
        type: 'POST',
        dataType: 'json',
        data: form_data,
        contentType: 'application/json; charset=utf-8',
        headers: {
            "X-API-KEY": "61b30e6d878e2a001d194b7c-Bdmzn4dtofWsNb79ch1bK0Bclw83NhuUbZry1bIJIPUT8GkQsG",
            "Content-Type": "application/json"
        },
        success: function (data, textStatus, xhr) {
            console.log(data);

        },
        error: function (xhr, textStatus, errorThrown) {
            console.log('Error in Operation', errorThrown);
            console.log('eeeeew', xhr, textStatus)

        }
    });

}